import { render, staticRenderFns } from "./IconCapitalizationCross.vue?vue&type=template&id=72abb63a&"
import script from "./IconCapitalizationCross.vue?vue&type=script&lang=js&"
export * from "./IconCapitalizationCross.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports